$(document).ready(function() {
    if ($(".breadcrumbs").length) {
        let $breadcrumbs = $(".breadcrumbs");
        let $breadCount = $breadcrumbs.children().length;
        let $breadParent = $breadcrumbs.parent();
        let charCap = 13;

        var mq = window.matchMedia( "(max-width: 768px)" );

        if (mq.matches) {
            mobileBreadcrumbs();  
        } 

        $(window).on('resize', function(){
            if (mq.matches) {
                mobileBreadcrumbs(); 
            } else {
                fullBreadcrumbs();
            }
        });

        function mobileBreadcrumbs() { 
            if ($breadcrumbs.width() > $breadParent.width() / 2 || $breadCount >= 5) {
                $(".breadcrumbs a").each(function(index, value) {
                    if (index > 0) {
                        var title = $(this).attr('title');
						
                        if (title.length > charCap) {
                            $(this).text(title.substring(0, 10) + "...");
                        }
                    }
                });
            }
        }
		
        function fullBreadcrumbs() { 

            $(".breadcrumbs a").each(function(index, value) {
                if (index > 0) {
                    var title = $(this).attr('title');
                    $(this).text(title);
                }
            });
        }
    }
});